import axiosInstance from '@/api/axiosInstance';

export const createShippingAddress = async (data) => {
  const response = await axiosInstance.post('/users/me/shipping-addresses', data);
  return response.data;
}; 

export const updateShippingAddress = async (id, data) => {
  const response = await axiosInstance.put(`/users/me/shipping-addresses/${id}`, data);
  return response.data;
};

export const deleteShippingAddress = async (id) => {
  const response = await axiosInstance.delete(`/users/me/shipping-addresses/${id}`);
  return response.data;
};

export const getShippingAddresses = async () => {
  const response = await axiosInstance.get('/users/me/shipping-addresses');
  return response.data;
}; 

export const getAddressByPostalCode = async (code) => {
  const response = await axiosInstance.get(`/postal-codes`, {
    params: { code }
  });
  return response.data;
}; 